import { dateTime } from './contractDetails'

export function agreementDetail(market, info) {
  const hk = market === 'hk' || market === 'us'
  const deposits = [hk ? info.deposit_money : info.deposit, info.append_deposit, info.expand_deposit]
  return {
    atime: hk ? info.begin_time : info.atime,
    etime: hk ? info.end_time : info.etime,
    ctime: hk ? info.begin_time : info.ctime,
    funding: (hk ? info.allocation_money : info.funding) == null ? '--' : (hk ? info.allocation_money : info.funding),
    ratio: info.ratio == null ? '--' : info.ratio,
    day_type: info.day_type == null ? '--' : info.day_type,
    totalDeposit: deposits.every(value => value != null && value !== '' && Number.isFinite(Number(value))) ? deposits.reduce((sum, value) => sum + Number(value), 0) : '--'
  }
}

export function agreementDate(value) {
  if (value == null || String(value).includes('undefined')) return '--'
  const [timestamp, part] = String(value).split('_')
  const formatted = dateTime(timestamp)
  if (formatted === '--') return formatted
  const ranges = { y: [0, 4], m: [5, 7], d: [8, 10] }
  return ranges[part] ? formatted.slice(...ranges[part]) : formatted
}

// H5 协议金额大写展示规则（整数金额，不改动实际合约金额）。
export function chineseAmount(amount, currency = '元') {
  if (amount == null || amount === '' || !Number.isFinite(Number(amount)) || Number(amount) < 0 || Number(amount) >= 1e12) return '--'
  if (Number(amount) === 0) return `零${currency}整`
  const digital = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const position = ['仟', '佰', '拾', '亿', '仟', '佰', '拾', '万', '仟', '佰', '拾', currency]
  const integer = Math.floor(Number(amount)).toString()
  let result = ''
  for (let i = 0; i < integer.length; i++) {
    const unit = position.length - integer.length + i
    if (integer[i] !== '0') result += digital[Number(integer[i])] + position[unit]
    else if ((unit + 1) % 4 === 0) result += position[unit]
  }
  return result + '整'
}
